// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d35c4f87","665":"3a042321","842":"8ed32a84","969":"7374388f","976":"434a4a2f"}[chunkId] + ".chunk.js";
};